const translations = {
    clientIsRequired: 'Client is required',
    clientsDropdownFieldLabel: 'CLIENTS'
};

export default translations;
